module.exports = __webpack_public_path__ + "static/media/petzenpro-2.f4700802.jpg";